module.exports = __webpack_public_path__ + "static/media/1045.44ca9407.jpg";